export default {
    Name: '',
    FirstName: '',
    MiddleName: '',
    Birthday: '',
    PassportSeries: '',
    PassportNumber: '',
    IsInternationalPassport: false,
    FullConditions: false,
    AgreementCode: '',
}